import { render } from "./Trustees.vue?vue&type=template&id=cc22a1ba&scoped=true&ts=true"
import script from "./Trustees.vue?vue&type=script&lang=ts"
export * from "./Trustees.vue?vue&type=script&lang=ts"

import "./Trustees.vue?vue&type=style&index=0&id=cc22a1ba&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc22a1ba"]])

export default __exports__